/**
 * Build greenfield FlightSearchSummary ViewModel from existing search form fields.
 * Presentation only — no search execution.
 */

import {
  formatLocationLabel,
  primaryLocation,
  summarizeRoomCompositions,
} from "../../../Components/FlightBookingFlowMockup/adapters/flightSearchDisplayAdapter";
import { formatFlightStayLabel } from "./buildGreenfieldDateStrip";

/**
 * @param {{
 *   origin?: object|null,
 *   location?: object|null,
 *   calendarDateArrival?: string|null,
 *   calendarDateLeave?: string|null,
 *   roomInfo?: object|null,
 *   flightTripType?: string|null,
 * }} input
 */
export function buildGreenfieldSearchViewModel(input = {}) {
  const originLoc = primaryLocation(input.origin);
  const destLoc = primaryLocation(input.location);
  const originCode =
    str(originLoc?.AIRPORTCODE || originLoc?.iata || originLoc?.code) || "—";
  const destCode =
    str(destLoc?.AIRPORTCODE || destLoc?.iata || destLoc?.code) || "—";
  const trip = String(input.flightTripType || "RoundTrip");
  const isOw = /one.?way/i.test(trip);
  return {
    origin: originCode,
    originCity: formatLocationLabel(originLoc || input.origin),
    destination: destCode,
    destinationCity: formatLocationLabel(destLoc || input.location),
    tripType: isOw ? "oneway" : "roundtrip",
    tripTypeLabel: isOw ? "כיוון אחד" : "הלוך-חזור",
    departDate: input.calendarDateArrival || null,
    departDateLabel: input.calendarDateArrival || "—",
    returnDate: isOw ? null : input.calendarDateLeave || null,
    returnDateLabel: isOw ? null : input.calendarDateLeave || null,
    passengers: null,
    passengersLabel: summarizeRoomCompositions(input.roomInfo),
    stayLabel: isOw
      ? null
      : formatFlightStayLabel(input.calendarDateArrival, input.calendarDateLeave),
    cabin: null,
    cabinLabel: null,
  };
}

function str(v) {
  if (v == null) return null;
  const s = String(v).trim();
  return s || null;
}
